// widgets/player/cmd/PlayerServerCommand.ts
var PlayerServerCommand;
(function (PlayerServerCommand) {
    PlayerServerCommand["play"] = "play";
    PlayerServerCommand["playWebFootage"] = "play-web-footage";
    PlayerServerCommand["editFootage"] = "edit-footage";
    PlayerServerCommand["setFootageParams"] = "set-footage-params";
    PlayerServerCommand["sceneInserted"] = "scene-inserted";
    PlayerServerCommand["sceneUpdated"] = "scene-updated";
    /** Колбэк после наведения на футаж для воспроизведения */
    PlayerServerCommand["videoInfo"] = "videoInfo";
})(PlayerServerCommand || (PlayerServerCommand = {}));

export { PlayerServerCommand };
